import { render, staticRenderFns } from "./EmpresasNueva.vue?vue&type=template&id=3d8d5e93&scoped=true"
import script from "./EmpresasNueva.vue?vue&type=script&lang=js"
export * from "./EmpresasNueva.vue?vue&type=script&lang=js"
import style0 from "./EmpresasNueva.vue?vue&type=style&index=0&id=3d8d5e93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d5e93",
  null
  
)

export default component.exports